


























































import {Component, Vue} from 'vue-property-decorator';
import { mapFields } from 'vuex-map-fields';
import ClickListener from '@/components/functional/ClickListener.vue';
import WakeLockService from '@/components/functional/WakeLockService.vue';
import HeatmapOverlay from '@/components/HeatmapOverlay.vue';
import DIListener from '@/components/functional/DIListener.vue';
import GlobalEvents from './logic/GlobalEvents';

@Component({
    computed: {
        ...mapFields('settings', [
            'host',
        ]),
    },
    components: {
        ClickListener,
        HeatmapOverlay,
        DIListener,
        WakeLockService
    }
})
export default class App extends Vue {

    private refreshPages = [
        'performance',
        'performance-direct',
        'home',
        'host'
    ];

    private refreshing: boolean = false;

    private mounted() {

        // refresh if back in use
        document.addEventListener("focus", this.clickRefresh);

        // Listen to resize event to adapt content size
        // Used to avoid content falling off-screen by mobile url-bar showing
        window.addEventListener('resize', this.resizeForUrlBar);
        // do it now for the first time
        this.resizeForUrlBar();
    }

    // prevent overlap with URL bar:
    private resizeForUrlBar() {
      // Calculate a replacement vh css property
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }

    private clickAbout() {

        // Close again if we are already on the about page
        if (this.$route.name === "about") {
            this.$router.back();
        } else {
            this.$router.push('/about').catch((err) => { return; });
        }
    }

    private clickSettings() {

        // Close again if we are already on the about page
        if (this.$route.name === "settings") {
            this.$router.back();
        } else {
            this.$router.push('/settings').catch((err) => { return; });
        }
    }

    private clickRefresh() {

        GlobalEvents.$emit('local-refresh');
        this.refreshing = true;
        GlobalEvents.$on('local-refresh-done', () => {
            this.refreshing = false;
            GlobalEvents.$off('local-refresh-done');
        });
    }
}
